import { find, get } from "lodash";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { INSURANCE_PLAN_PARAMS_RULES } from "utils/constants";

export const useGetDocumentName = (subscription) => {
  const { user } = useContext(StoreContext);
  const { t: f } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const DOCUMENT_NAME = f("DOCUMENT_NAME", { returnObjects: true });
  const organizationDocumentNames = get(
    DOCUMENT_NAME,
    get(user, "organization.config.envelop"),
    {},
  );
  const insurancePlanDocumentParams = get(
    find(get(subscription, "insurancePlan.params.0.rules", []), {
      name: INSURANCE_PLAN_PARAMS_RULES.DOCUMENTS,
    }),
    "value.0.documents",
    [],
  );

  const getDocumentName = ({ type, defaultName = " " }) => {
    const param = find(insurancePlanDocumentParams, { documentName: type });
    const configName = get(param, "fileName");
    return (
      configName ||
      get(
        organizationDocumentNames,
        `${type}.${get(param, "documentVersion")}`,
      ) ||
      defaultName
    );
  };

  return getDocumentName;
};
